<div class="du-chat-search-bar">
    <input type="text" placeholder="Search contacts" [(ngModel)]="searchUsers"/>
</div>

<ul class="du-chat-contact-list">
    <li *ngFor="let contact of filteredContacts()" class="du-chat-contact-item" (click)="userSelection(contact)">
        <div class="du-chat-avatar-wrapper">
            <img [src]="contact.gender !== 'F' ? 'assets/man.png' : 'assets/women.png'" alt="Avatar" class="du-chat-avatar">
            <span class="du-chat-status-dot" [class.online]="contact.online" [class.offline]="!contact.online"></span>
        </div>
        <div class="du-chat-contact-details">
            <h4>{{ contact.usr_display_nm }}</h4>
            <p>{{ contact.lastMessage }}</p>
        </div>
        <span class="du-chat-message-time">{{ contact.lastSeen }}</span>
    </li>
</ul>